import axios from 'axios'
import jwtDecode from 'jwt-decode'
import { apiService, getAuthHeader } from './api.service'
import { Jwt } from '../hooks/useAuth'
import store from '../redux/store'

function loginUser(loginForm: { username: string; password: string }): Promise<string> {
  return axios
    .post(
      apiService.getFullApiUrl('/auth/login'),
      {
        ...loginForm,
      },
    )
    .then((response) => response.data.data)
}

let logoutInFlight: Promise<void> | null = null

function logout(): Promise<void> {
  if (logoutInFlight) return logoutInFlight

  const accessToken = localStorage.getItem('accessToken')
  if (!accessToken) return Promise.resolve()

  logoutInFlight = axios
    .delete(apiService.getFullApiUrl('/auth/logout'), { headers: getAuthHeader(accessToken) })
    .then(() => undefined)
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Logout failed', error?.message)
    })
    .finally(() => {
      localStorage.removeItem('accessToken')
      logoutInFlight = null
    })

  return logoutInFlight
}

function endSession() {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('tardekSearch')
  localStorage.removeItem('search')
  store.dispatch({ type: 'RESET_DECLARATION' })
  window.location.replace('/login')
}

function signOut(): Promise<void> {
  return logout().finally(endSession)
}

function eagerlyLogoutWhenTokenExpireDateImpending() {
  const accessToken = localStorage.getItem('accessToken')
  if (accessToken) {
    let decodedToken: Jwt
    try {
      decodedToken = jwtDecode(accessToken)
    } catch {
      localStorage.removeItem('accessToken')
      // eslint-disable-next-line no-console
      console.error('Unable to decode access token')
      return
    }
    const dateTokenWillExpire = new Date(decodedToken.exp * 1000)
    // @ts-ignore
    const diff = dateTokenWillExpire - (new Date())
    if (diff < 0) {
      signOut()
    }
    const hoursUntilTokenExpired = parseInt(`${diff / (60 * 60 * 1000)}`, 10)
    if (hoursUntilTokenExpired < 2) {
      setTimeout(signOut, 2000)
    }
  }
}

function submitOtpRequest(username: string, otp: string) {
  return axios
    .post(
      apiService.getFullApiUrl('/auth/otp'),
      {
        username, otp,
      },
    )
    .then((response) => response.data.data)
}

const AuthenticationService = {
  loginUser,
  logout,
  signOut,
  eagerlyLogoutWhenTokenExpireDateImpending,
  submitOtpRequest,
}

export default AuthenticationService
